import React, { useState, useEffect } from "react";
import fetchProductReviews from "services/fetch-product-reviews";
import { Script } from "gatsby";

const ProductRichSnippets = ({ product }) => {
	const [structuredData, setStructuredData] = useState(null);

	const fetchReviews = async () => {
		const reviews = await fetchProductReviews(product.variant.sku);
		if (reviews) {
			const updatedStructuredData = {
				"@context": "https://schema.org/",
				"@type": "Product",
				name: product.title,
				image: product.image,
				description: product.shortDescription,
				sku: product.variant.sku,
				brand: {
					"@type": "Brand",
					name: "Every",
				},
				aggregateRating: {
					"@type": "AggregateRating",
					ratingValue: reviews.average,
					reviewCount: reviews.count,
				},
			};
			setStructuredData(updatedStructuredData);
		}
	};

	useEffect(() => {
		fetchReviews();
	}, []);

	return (
		<>
			{structuredData &&
				<Script type="application/ld+json">{JSON.stringify(structuredData)}</Script>
			}</>
	);
};

export default ProductRichSnippets;
